import { v4 as uuidv4 } from 'uuid';

export function NewsletterSubmit(props = {}) {
	return {
		componentName: 'NewsletterSubmit',
		componentId: uuidv4(),
		props: Object.assign(
			{
				blockClass: 'newsletter__button-submit',
				submitButtonLabel: 'Cadastre-se',
			},
			props,
		),
		childrenComponents: [],
	};
}
